<template>
  <ValidationObserver ref="observer" v-slot="{ invalid }">
    <tsny-modal
      :modal-id="modalId"
      :modal-title="'New Course'"
      :submit-button-text="'CREATE'"
      :submit-disabled="invalid"
      :reset-modal="resetModal"
      :submit-modal="createCourse"
    >
      <b-row>
        <b-col>
          <BTextInputValidated
            rules="required"
            type="text"
            label="Course/Exam Name"
            v-model="name"
            name="name"
          />
        </b-col>
      </b-row>
      <b-row class="tsny_input-group">
        <b-col>
          <BTextInputValidated
            text-area
            type="text"
            label="Description"
            v-model="description"
            placeholder="Optional, but like there should probably be one"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <p class="tsny_status-text" v-if="createCourseError">
            An error occurred creating the new course object
          </p>
        </b-col>
      </b-row>
    </tsny-modal>
  </ValidationObserver>
</template>

<script>
import CourseRestService from "../../services/rest/services/CourseRestService";
import TsnyModal from "../TsnyModal";
import { ValidationObserver } from "vee-validate";
import BTextInputValidated from "../FormInputs/BTextInputValidated";

export default {
  name: "CreateCourseModal",
  components: { tsnyModal: TsnyModal, ValidationObserver, BTextInputValidated },
  data: function() {
    return {
      modalId: "createCourseModal",
      name: null,
      description: null,
      createCourseError: null
    };
  },
  methods: {
    createCourse: async function(bvModalEvt) {
      bvModalEvt.preventDefault();
      let $comp = this,
        isValid = await this.$refs.observer.validate();

      if (!isValid) return;

      $comp.createCourseError = false;

      return CourseRestService.createCourse($comp.name, $comp.description)
        .then(() => {
          $comp.$bvModal.hide($comp.modalId);
        })
        .catch(err => {
          $comp.createCourseError = true;
          console.log(err);
        });
    },
    resetModal: function() {
      this.name = null;
      this.description = null;
      this.createCourseError = null;
    }
  }
};
</script>

<style scoped></style>
